import type { Icon } from "@tabler/icons-react";
import { IconApi, IconBook, IconBrandAndroid, IconBrandApple, IconBrandReact, IconCpu, IconDeviceMobile, IconPackage, IconSparkles } from "@tabler/icons-react";
import { brand } from "../theme/brand";
import { easyAiOrigin, publicApiBase } from "./clients";

export interface DocLink {
  label: string;
  description?: string;
  icon?: Icon;
  /** External URL, or an in-app path when `internal`. */
  href: string;
  internal?: boolean;
}

export interface DocGroup {
  label: string;
  links: DocLink[];
}

const book = (path: string) => `${brand.docsUrl}/${path}`;

/** Every documentation link, for the header menu. Functions of the deployment so dev links to dev hosts. */
export function docGroups(): DocGroup[] {
  const easyAi = easyAiOrigin();
  return [
    {
      label: "Passio API",
      links: [
        { label: "API reference", description: "Every route, schema and header (OpenAPI)", icon: IconApi, href: `${publicApiBase()}/docs` },
        { label: "REST API guide", description: "Overview, auth and quickstart", icon: IconBook, href: book("rest-api/api-overview") },
        { label: "Usage guide", description: "Search, recognition, barcodes, details", href: book("rest-api/usage-guide") },
        { label: "Tokens and pricing", href: book("getting-started/token-system-and-pricing") },
      ],
    },
    {
      label: "Mobile SDKs",
      links: [
        { label: "iOS SDK", icon: IconBrandApple, href: book("mobile-sdks/ios-sdk-docs") },
        { label: "Android SDK", icon: IconBrandAndroid, href: book("mobile-sdks/android-sdk-docs") },
        { label: "React Native SDK", icon: IconBrandReact, href: book("mobile-sdks/react-native-sdk-docs") },
        { label: "Flutter SDK", icon: IconDeviceMobile, href: book("mobile-sdks/flutter-sdk-docs") },
        { label: "API or SDK?", description: "Which to use, and using both", href: book("getting-started/api-vs-sdk") },
      ],
    },
    {
      label: "Easy AI",
      links: [
        { label: "Build a NutritionAI app in Studio", description: "Sign in with your Passio account", icon: IconSparkles, href: `${easyAi}/dashboard/playground?platform=nutrition&new=1` },
        { label: "Easy AI Studio", description: "Functions, chains, knowledge bases", href: `${easyAi}/dashboard` },
        { label: "Custom endpoints with Easy AI", href: book("rest-api/custom-api-endpoints-with-easy-ai") },
      ],
    },
    {
      label: "In this demo",
      links: [
        { label: "API guide", description: "Headers, request IDs, feedback", icon: IconBook, href: "/guide", internal: true },
        { label: "Models", icon: IconCpu, href: "/models", internal: true },
        { label: "Client SDKs", icon: IconPackage, href: "/developers", internal: true },
      ],
    },
    {
      label: "Help",
      links: [
        { label: "Passio docs home", href: book("readme") },
        { label: "Get your Nutrition AI key", href: book("getting-started/get-your-nutrition-ai-key") },
        { label: "Support", href: book("getting-started/support") },
      ],
    },
  ];
}
